import { captureException } from '@sentry/react';
import loglevel from 'loglevel';

import { config } from '../config';

if (config.dev.logToConsole) {
    loglevel.enableAll();
} else {
    loglevel.disableAll();
}

const { warn, info, trace, debug } = loglevel;

const error = <Args extends any[]>(...args: Args) => {
    const error = args[0];
    loglevel.error(...args);
    captureException(error);
};

export const logger = {
    warn,
    info,
    trace,
    debug,
    error,
};
